module.exports = __webpack_public_path__ + "img/clipboard.85c4cafa.svg";